import React from 'react';
import {
  LibraryItemSortBy,
  Orientation,
} from '@wix/ambassador-file-sharing-v1-settings/types';
import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from '../TableHeader.st.css';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';

const LastUpdatedComponent = ({
  name,
  sortBy,
  orientation,
  handleTitleColumnOnClick,
  disabledTableHeader,
  isMembersArea,
}: any) => {
  const className = disabledTableHeader ? classes.disabledHeader : '';

  const suffixIcon: any =
    sortBy === LibraryItemSortBy.LAST_MODIFIED &&
    (orientation === Orientation.DESC ? (
      <SortDown className={className} />
    ) : (
      <SortUp className={className} />
    ));
  return (
    <div
      style={{
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
      }}
    >
      <TextButton
        className={st(classes.tableHeaderColumn, { isMembersArea })}
        contentClassName={classes.contentEllipsis}
        suffixIcon={suffixIcon}
        priority={TextButtonPriority.secondary}
        onClick={() => {
          if (!disabledTableHeader) {
            handleTitleColumnOnClick({
              sortBy,
              selectedId: LibraryItemSortBy.LAST_MODIFIED,
            });
            biService(
              { button_description: 'date', is_first: false },
              BI_FILE_SHARE_WIDGET_SORT_BY,
            );
          }
        }}
        title={name}
      >
        {name}
      </TextButton>
    </div>
  );
};
export default LastUpdatedComponent;
